import {IReactionDisposer, makeAutoObservable} from "mobx";


export class WithDisposers {

    private disposers: Array<IReactionDisposer | { (): void }> = []

    constructor() {
        makeAutoObservable(this)
    }

    subscribe(...disposers: Array<IReactionDisposer | { (): void }>) {
        disposers.forEach(disposer => {
            this.disposers.push(disposer)
        })
    }

    unsubscribe() {
        this.disposers.forEach(dispose => dispose());
        this.disposers = [];
    }
}